import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const productsPaymentApi = createApi({
  reducerPath: "productsPaymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Products"],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ workspaceId }) => `/workspaces/${workspaceId}/products`,
      providesTags: (result, error, { workspaceId }) => [
        { type: "Products", id: workspaceId },
      ],
    }),
    createProduct: builder.mutation({
      query: (body) => ({ url: "/products", method: "POST", body }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "Products", id: workspaceId },
      ],
    }),
    updateProduct: builder.mutation({
      query: (body) => ({ url: "/products", method: "PATCH", body }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "Products", id: workspaceId },
      ],
    }),
    archiveProduct: builder.mutation({
      query: (body) => ({ url: "/products/archive", method: "POST", body }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "Products", id: workspaceId },
      ],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useArchiveProductMutation,
} = productsPaymentApi;
